import { FormControl, FormErrorMessage, InputGroup } from '@chakra-ui/react';
import { Control, Controller, FieldError, FieldValues } from 'react-hook-form';
import ReactSelectLib, { Props as SelectProps } from 'react-select';

interface IProps extends SelectProps {
  name: string;
  label?: string;
  width?: string;
  // eslint-disable-next-line @typescript-eslint/ban-types
  control?: Control<FieldValues, object>;
  error?: FieldError | any;
  isRequired?: boolean;
  options: any[];
}

const AutocompleteSelect: React.FC<IProps> = ({
  label,
  name,
  width,
  error = null,
  isRequired,
  control,
  options,
  ...rest
}) => {
  return (
    <FormControl isInvalid={!!error} isRequired={isRequired}>
      <InputGroup>
        <Controller
          control={control}
          name={name}
          render={({ field: { onBlur, onChange, value } }) => (
            // Talvez estilizar o componente
            <ReactSelectLib
              styles={{
                control: baseStyles => ({
                  ...baseStyles,
                  width: width || '150px',
                  backgroundColor: '#EDF2F7',
                  borderWidth: 0,
                }),
              }}
              options={options}
              value={value}
              placeholder={label}
              onChange={onChange}
              onBlur={onBlur}
              {...rest}
            />
          )}
        />
      </InputGroup>
      {!!error && <FormErrorMessage>{error?.value?.message}</FormErrorMessage>}
    </FormControl>
  );
};

export default AutocompleteSelect;
